import subscriptions from './subscriptions';
import subscriptions412 from './subscriptions412';
import calculationofpayments from './calculationofpayments';
import grksubscriptions from './grksubscriptions';
import households from './households';

export default {
  subscriptions,
  subscriptions412,
  calculationofpayments,
  grksubscriptions,
  households,
};
